import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type {
  CreatePolicyParams,
  CreatePolicyResponse,
} from '@/api/policies/create-policy'

export const mockCreateOrUpdatePolicy = http.post<never, CreatePolicyParams>(
  '/my-business/api/agency/v1/*/:companyAlphaId/policies',
  async ({ request }) => {
    const { name } = await request.json()

    if (name === 'error') {
      return HttpResponse.json({ message: 'Error' }, { status: 400 })
    }

    const data: CreatePolicyResponse = {
      alphaId: faker.string.uuid(),
      version: Number(faker.string.numeric(2)),
      code: Number(faker.string.numeric(4)),
    }

    return HttpResponse.json(data, { status: 201 })
  },
)
